import axios from 'axios'

const path = 'report'

export default {
  async listTsReports(q, pageRequest) {
    const resp = await axios.get(`${path}/timestamp`, {
      params: {
        ...q,
        ...pageRequest
      }
    })
    return resp.data
  },

  async exportTsReportFile(useDelete = false, q) {
    const resp = await axios.get(`${path}/timestamp/export`, {
      params: {
        'useDelete': useDelete,
        ...q
      },
      responseType: 'blob'
    })
    return resp.data
  }
}
